/* global SideDrawer, debounce */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

if (!customElements.get('cart-drawer-gift-options')) {
  class CartDrawerGiftOptions extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick || this.onClick.bind(this);
      this.handleMessageInput = this.handleMessageInput || debounce(this.onMessageInput.bind(this), 300);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('input', this.handleMessageInput);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('input', this.handleMessageInput);
    }

    getSectionsToUpdate() {
      return ['page-header', 'cart-drawer']
        .map((sel) => document.querySelector(sel))
        .filter((el) => el);
    }

    updateSections(data) {
      const sectionsToUpdate = this.getSectionsToUpdate();
      if (!data.sections || sectionsToUpdate.length !== Object.keys(data.sections).length) {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
        return;
      }

      sectionsToUpdate.forEach((el) => {
        el.updateFromCartChange(data.sections[el.dataset.sectionId]);
      });
    }

    async onClick(evt) {
      const button = evt.target.closest('[data-variant-id]');
      if (!button || button.disabled) return;

      evt.preventDefault();
      button.disabled = true;
      button.classList.add('is-loading');

      const formData = new FormData();
      const sectionIds = this.getSectionsToUpdate().map((el) => el.dataset.sectionId);
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sectionIds.join(','));

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || response.status);
        }

        this.updateSections(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }

    onMessageInput(evt) {
      const input = evt.target.closest('textarea[name^="attributes["]');
      if (!input) return;

      const attributeKey = this.dataset.giftMessageKey;
      if (!attributeKey) return;

      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [attributeKey]: input.value
          }
        })
      });
    }
  }

  customElements.define('cart-drawer-gift-options', CartDrawerGiftOptions);
}
